<div class="dialog-container" >
    <div class="header">
        <p class="white inline-block"><b>{{data.title}}</b></p>
    </div>
    <div class="content">
        <p display-2 [innerHTML]="data.message"></p>
        <div class="confirm-buttons uk-text-center margin-top-20">
            <button class=" uk-button uk-button-thin no" (click)="onDismiss()">No</button>
            <button class=" uk-button uk-button-thin uk-button-primary yes" (click)="onConfirm()">Yes</button>
        </div>
    </div>
</div>